var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Clock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-75.000000, -8.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Clock",
    transform: "translate(75.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50040191,0.5 C9.43012193,0.5 11.1798553,1.28532392 12.44726,2.55279652 C13.7147303,3.82033482 14.5,5.57024566 14.5,7.5 C14.5,9.42975434 13.7147303,11.1796652 12.44726,12.4472035 C11.1798553,13.7146761 9.43012193,14.5 7.50040191,14.5 C5.57060833,14.5 3.82062775,13.7146214 2.55301383,12.4470754 C1.28542244,11.1795519 0.5,9.42969557 0.5,7.5 C0.5,5.57030443 1.28542244,3.8204481 2.55301383,2.55292463 C3.82062775,1.28537863 5.57060833,0.5 7.50040191,0.5 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7477112,8.05495045 L7.57710491,8.05495045 C7.49679135,7.839431 7.30702167,7.67004112 7.06466726,7.59799097 L7.06466726,3.22563204 C7.06466726,3.10112101 6.95094992,3 6.81094112,3 C6.67093233,3 6.55792458,3.10112587 6.55792458,3.22563204 L6.55792458,7.59750556 C6.22672509,7.69483881 6,7.96788512 6,8.28011326 C6,8.67702825 6.3638955,9 6.81023153,9 C7.1620457,9 7.46979212,8.79901031 7.57710491,8.5057453 L11.7469835,8.5057453 C11.8869977,8.5057453 12,8.40461943 12,8.28011326 C12,8.15560709 11.8877037,8.05511225 11.7476931,8.05511225 L11.7477112,8.05495045 Z",
    id: "Fill-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.776e86944f47c272d25d03fb80baff30.svg";
export { ForwardRef as ReactComponent };